import { createAction } from '@reduxjs/toolkit';

import { ILand } from 'state/types';

export const setLands = createAction<ILand[]>('lands/getLands');
export const updateLand = createAction<ILand>('lands/updateLand');
